export default __webpack_public_path__ + "static/media/post_one.png";